export default __webpack_public_path__ + "static/media/Archdeacon's Girdle of the Eighteen Pits.6fe48bab.jpg";